import { ReportService } from '@/app/reports/share/report.service'
import { ref } from '@vue/composition-api'
import store from '@/store'


export default function reportForm() {

  const devices = ref([])
  const geofences = ref([])

  const type = ref('inside')

  ReportService.getDevicesOptions({
    type:'device',
    user: store.state.auth.userData.id
  }).then(response => devices.value = response.data.map((d)=>({id:d.device_id,"name":d.name})))


  ReportService.getCategoriesOptionsBy({
    type:'forbidden_areas',
    user: store.state.auth.userData.id
  }).then(response => geofences.value = response.data.map((d)=>({id:d.geofence_id,"name":d.name})))


  return {
    devices,
    geofences,
    type
  }
}
